
























































































































import { RareLevelColors } from '@/constants'
import { HeroNftModel } from '@/models/hero-nft-model'
import { Observer } from 'mobx-vue'
import { Component, Inject, Prop, Vue } from 'vue-property-decorator'
import { MyCharacterViewmodel } from '../viewmodels/my-character-viewmodel'
@Observer
@Component({
  components: {},
})
export default class CharacterDetailDialog extends Vue {
  @Inject() vm!: MyCharacterViewmodel
  @Prop({ default: {} }) character!: HeroNftModel

  get color() {
    return RareLevelColors.find((item) => item.name === this.character.rareLevel)?.color || 'black'
  }
}
